var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1844 8.5077C15.5433 8.5077 8.54368 15.4779 8.54368 24.0827C8.54368 32.6875 15.5433 39.6577 24.1844 39.6577C32.8255 39.6577 39.8251 32.6875 39.8251 24.0827C39.8251 15.4779 32.8255 8.5077 24.1844 8.5077ZM7.18799 24.0827C7.18799 14.7323 14.7945 7.1577 24.1844 7.1577C33.5743 7.1577 41.1808 14.7323 41.1808 24.0827C41.1808 33.4331 33.5743 41.0077 24.1844 41.0077C14.7945 41.0077 7.18799 33.4331 7.18799 24.0827Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2721 16.54C27.5389 16.8015 27.5423 17.2289 27.2796 17.4945L21.0467 23.7995C20.9138 23.9339 20.9138 24.108 21.0467 24.2425L27.2796 30.5475C27.5423 30.8131 27.5389 31.2405 27.2721 31.502C27.0053 31.7635 26.5761 31.7602 26.3135 31.4945L20.0806 25.1896C19.4282 24.5297 19.4282 23.5123 20.0806 22.8524L26.3135 16.5475C26.5761 16.2818 27.0053 16.2784 27.2721 16.54Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/go-back.8e850e97e4232196f1cec3e3338db519.svg";
export { ForwardRef as ReactComponent };